import React from 'react';
import { mock_projects } from '../../utils/data';
import { projectConfig } from '../../utils/configs';
import { Header, PageContainer, PageContent, Sidebar } from '../../layouts';
import { ButtonLink, DataGrid, TitleLarge } from '../../components';
import { CREATE_PROJECT_ROUTE, PLUS_ICON } from '../../utils/consts';

const ProjectsPage = () => {
	return (
		<>
			<Header />
			<PageContainer>
				<Sidebar />
				<PageContent>
					<TitleLarge>Projekte</TitleLarge>
					<div className='d-flex justify-content-end mb-3'>
						<ButtonLink
							route={CREATE_PROJECT_ROUTE}
							icon={PLUS_ICON}
							classes={'background-green px-4 py-2'}>
							Projekt erstellen
						</ButtonLink>
					</div>
					<DataGrid
						data={mock_projects}
						config={projectConfig}
						keyExtractor={(project) => project.project_id}
					/>
				</PageContent>
			</PageContainer>
		</>
	);
};

export default ProjectsPage;
